
<div class="relative">
  <poppins-notification
    id="profile-link-toast"
    class="-mt-16"
    message="Sitter profile link copied to clipboard."
    :triggerNotification="showToast"
    @toggleVisibility="closeToast"
  />
  <div class="flex justify-between items-center">
    <poppins-breadcrumb :header="breadcrumbInfo.header" class="mt-0" :href="breadcrumbInfo.link" anchorLink />
    <div v-if="accountTypeInfo.isParent" class="flex gap-8">
      <provider-profile-favorite-sitter-button
        :favoritedSitter="favoritedSitter"
        :sitterAccountId="sitterAccountId"
        class="self-center"
        @favoritedSitterChange="favoritedSitterChange"
      />
      <action-menu :menuOptions="kebabOptions" iconType="kebab" noBackground />
    </div>
  </div>
</div>
